import http from './http';
import { listResource } from './listResource';

export async function listEvaluationCriteria(options = {}) {
  return listResource('/evaluation-criteria', options);
}

/**
 * Obtiene un criterio de evaluación por su ID.
 */
export async function getEvaluationCriteriaById(id) {
  const res = await http.get(`/evaluation-criteria/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un criterio de evaluación.
 */
export async function updateEvaluationCriteria(id, userData) {
  const res = await http.put(`/evaluation-criteria/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Crear un criterio de evaluación.
 */
export async function createEvaluationCriteria(userData) {
  const res = await http.post(`/evaluation-criteria/`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Eliminar criterio de evaluación
 */
export const deleteEvaluationCriteria = (id) => http.delete(`/evaluation-criteria/${id}`);


/**
 * Activar/Desactivar criterio de evalaución
 */
export const updateEvaluationCriteriaStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/evaluation-criteria/status/${id}`, { is_active: isActive });


/**
 * Revisar que no este en uso el criterio o el código.
 */
export async function checkCriteriaExists(title, excludeId = null) {
  try {
    const { items } = await listEvaluationCriteria({ search: title });
    const exists = items?.some(
      (item) =>
        item.description?.toLowerCase() === title?.toLowerCase() &&
        item.id !== Number(excludeId)
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar la modalidad:', error);
    return false;
  }
}
